import Vue from 'vue';
import Vuex from 'vuex';
import {loadState, saveState} from './localstorage-manager';
import {getters} from './getters';
import {mutations} from './mutations';
import helpers from '@app/helpers';
import Raven from 'raven-js';
import * as cloneDeep from 'lodash/cloneDeep';

Vue.use(Vuex);

export default new Vuex.Store({
	state: loadState,
	getters,
	mutations,
	plugins: [saveState],
	actions: {

		addLineItem({commit}, data) {

			const portion = helpers.methods.getItemById(data.display.product.defaultPortionId, data.product.portions);

			if (!portion) {

				Raven.captureBreadcrumb({
					message: 'Portion does not exist',
					category: 'menu',
					data: {
						product: data.product.name,
						portions: data.product.portions,
						defaultPortionId: data.display.product.defaultPortionId
					}
				});

			} else {

				const lineItem = {
					item: {
						itemId: data.item.itemId,
						sortOrder: data.item.sortOrder,
						product: data.product
					},
					portion: portion,
					displayName: data.display.product.displayName,
					isInvalid: false,
					basePrice: portion.price,
					totalPrice: portion.price * data.quantity, /* Should include choice prices */
					choices: [],
					basketItemId: Date.now(),
					quantity: data.quantity,
					displayRecordId: data.display.product.displayRecordId
				};

				if (data.choices) {
					lineItem.choicePriceTotal = data.choicePriceTotal;
					lineItem.totalPrice = (data.choicePriceTotal + lineItem.basePrice) * lineItem.quantity;
					lineItem.choices = data.choices;
				}

				const uniqueLineItem = cloneDeep(lineItem);

				commit('ADD_LINE_ITEM', uniqueLineItem);

			}
		},

		selectMenu({commit}, id) {
			commit('SELECT_MENU', id);
		},

		/**
		 *	Set item (or item's choice) to be invalid after recieving an 'unavailable' response from the API.
		 */
		invalidateItem({commit}, id) {
			commit('INVALIDATE_ITEM', id);
		},

		/* Remove from basket lines */
		removeLineItem({commit}, id) {

			commit('REMOVE_ITEM', id);

			Raven.captureBreadcrumb({
				message: 'Removing item from basket',
				category: 'menu',
				data: {
					id: id
				}
			});
		},

		setBreakpoint({commit}, name) {
			commit('SET_BREAKPOINT', name);
		},

		updateLineItem({commit}, obj) {
			commit('UPDATE_ITEM', obj);
		},

		selectTimeslot({commit}, obj) {
			commit('SELECT_TIMESLOT', obj);
		},

		resetBasket({commit}) {
			commit('RESET_BASKET');
		},

		addLocations({commit}, array) {
			commit('ADD_LOCATIONS', array);
		},

		updateLocationsFromZonal({commit}, obj) {

			const request = {
				method: 'getVenueSummary'
			};

			if (obj.userCoords) {
				request.latitude = obj.userCoords.latitude;
				request.longitude = obj.userCoords.longitude;
				// request.maxResults = 50; /* Zonal only return all TRG venues - not brand specific */
			}

			/* Get all TRG venues */
			Vue.http
				.post('', 'request=' + JSON.stringify({request: request}), {})
				.then((res) => {

					if (res.status !== 200)
						throw Error(`HTTP POST REQUEST: ${name} failed to load`);

					const contentfulVenues = {};
					const zonalVenues = {};

					/* Loop contentful results + transform to Key/Value for ease of use later */
					for (let i = 0, len = obj.locations.length; i < len; i++) {
						const entry = obj.locations[i].fields;
						contentfulVenues[entry.zonalSiteId] = entry;
					}

					/* Match objects from Zonal on venues */
					for (let v in res.body.venues) {
						const zonalLocation = res.body.venues[v];
						if (contentfulVenues[zonalLocation.id]) {
							zonalVenues[zonalLocation.id] = Object.assign(contentfulVenues[zonalLocation.id], zonalLocation);
						}
					}

					/* Flat array of locations (keeps order unlike k/v object) */
					const array = Object.keys(zonalVenues).map(v => zonalVenues[v]);
					let sorted;

					/* Sort by distance if available */
					if (obj.userCoords) {

						sorted = array.sort((prev, current) => {
							if (prev.distance >= current.distance)
								return 1;
							else
								return -1;
						});

					} else {

					/* Sort alphabetically */
						sorted = array.sort((prev, current) => {
							if (prev.name >= current.name)
								return 1;
							else
								return -1;
						});
					}

					commit('ADD_LOCATIONS', sorted);

				}, (err) => {
					Raven.captureException('updateLocationsFromZonal failed', {
						extra: {
							zonalError: err
						}
					});
				});
		},

		updateLocations({commit}, array) {
			commit('UPDATE_LOCATIONS', array);
		},

		clearMenus({commit}, array) {
			commit('CLEAR_MENUS', array);
		},
		detectIframe({commit}) {
			commit('DETECT_IFRAME');
		},
		setBrand({commit}, brand) {
			commit('SET_BRAND', brand);
		},
		setOffline({commit}, status) {
			commit('SET_OFFLINE', status);
		},
		setLastRoute({commit}, path) {
			commit('SET_LAST_ROUTE', path);
		},
		setLocationsLoaded({commit}, bool) {
			commit('SET_LOCATIONS_LOADED', true);
		},
		setUiCopy({commit}, uiCopy) {
			commit('SET_UI_COPY', uiCopy);
		}
	}
});



// WEBPACK FOOTER //
// ./src/vue/store/index.js